define('../app/fukit/view/block/error.dimmer.view',['require','exports','module','underscore','marionette','backbone','uikit/uikit','../../helpers/extend.util','appkit/controller.service'],function(require, exports, module) {
  //prettier-ignore
  var _                 = require('underscore'),
      Mn                = require('marionette'),
      Backbone          = require('backbone'),
      UIKit             = require('uikit/uikit'),
      ExtendUtil        = require('../../helpers/extend.util'),
      ControllerService = require('appkit/controller.service');

  var VisibleOnlyWithActivePageBehavior = Mn.Behavior.extend({
    defaults: {
      invert: false,
    },

    onFirstRender: function() {
      this.view.visible = this.shouldBeVisible();
      this.listenTo(this.getRegion(), 'show empty', function() {
        this.view.visible = this.shouldBeVisible();
      });
    },

    shouldBeVisible: function() {
      var shouldBeVisible = this.doesActivePageExist();
      if (this.getOption('invert')) {
        shouldBeVisible = !shouldBeVisible;
      }
      return shouldBeVisible;
    },

    doesActivePageExist: function() {
      var region = this.getRegion();
      return region ? region.hasView() : false;
    },

    getRegion: function() {
      return ControllerService.getRegion();
    },
  });

  //prettier-ignore
  var currentRouteFragment = Backbone.history.fragment,
      previousRouteFragment;
  Backbone.history.on('route', function() {
    previousRouteFragment = currentRouteFragment;
    currentRouteFragment = Backbone.history.fragment;
  });

  var ErrorDimmerView = UIKit.Dimmer2.extend({
    options: _.extend({}, UIKit.Dimmer2.prototype.options, {
      inverted: true,
      page: true,
    }),

    content: function() {
      return {
        content: {
          type: UIKit.ComponentsContainerView,
          components: [
            _.extend(
              {
                type: UIKit.Header,
                tagName: 'h2',
                text: 'Something Went Wrong!',
                subText: 'The page was unable to load. Please try reloading the page again.',
              },
              Mn._getValue(this.getOption('header'), this)
            ),
            _.extend(
              {
                type: UIKit.ComponentsContainerView,
                spacing: 'uptight',
                childView: UIKit.Button,
                components: [
                  _.extend(
                    {
                      icon: 'reply',
                      text: 'Back to Home',
                      onPress: function() {
                        Backbone.history.navigate('', { trigger: true });
                      },
                      behaviors: {
                        CloseDimmerBehavior: {
                          behaviorClass: UIKit.Dimmer2.CloseDimmerBehavior,
                        },
                        VisibleOnlyWithActivePageBehavior: {
                          invert: true,
                          behaviorClass: VisibleOnlyWithActivePageBehavior,
                        },
                      },
                    },
                    this.getOption('backToHomeButton')
                  ),
                  _.extend(
                    {
                      text: 'Cancel',
                      onPress: function() {
                        Backbone.history.navigate(previousRouteFragment || '', { replace: true });
                      },
                      behaviors: {
                        CloseDimmerBehavior: {
                          behaviorClass: UIKit.Dimmer2.CloseDimmerBehavior,
                        },
                        VisibleOnlyWithActivePageBehavior: {
                          behaviorClass: VisibleOnlyWithActivePageBehavior,
                        },
                      },
                    },
                    this.getOption('cancelButton')
                  ),
                  _.extend(
                    {
                      icon: 'refresh',
                      color: 'primary',
                      text: 'Reload',
                      onPress: function() {
                        window.location.reload();
                      },
                    },
                    Mn._getValue(this.getOption('reloadButton'), this)
                  ),
                ],
              },
              Mn._getValue(this.getOption('actions'), this)
            ),
          ],
        },
      };
    },
  });

  module.exports = ErrorDimmerView;
});

